import { render, staticRenderFns } from "./FreshChatModule.vue?vue&type=template&id=3dc156e2"
import script from "./FreshChatModule.vue?vue&type=script&lang=js"
export * from "./FreshChatModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports